import {Link} from 'react-router-dom'

import CartContext from '../../context/CartContext'

import Header from '../Header/index'

import './index.css'

const WhishList = () => (
  <CartContext.Consumer>
    {values => {
      const {wishList} = values

      return (
        <div>
          <Header />
          <div className="main-div">
            {wishList.length > 0 ? (
              <div>
                <h1>WishList</h1>
                <ul className="products-list-wish">
                  {wishList.map(each => (
                    <li className="product-item-wish">
                      <h3>{each.title}</h3>
                      <p>{each.brand}</p>
                      <img
                        src={each.imageUrl}
                        alt={each.title}
                        className="thumbnail-wish"
                      />
                      <p>{each.rating}* rating</p>
                    </li>
                  ))}
                </ul>
                <Link to="/products">
                  <button type="button" className="empty-button">
                    Back
                  </button>
                </Link>
              </div>
            ) : (
              <div className="empty-wish">
                <h1>Your WishList is Empty</h1>
                <Link to="/products">
                  <button type="button" className="empty-button">
                    Shop Now
                  </button>
                </Link>
              </div>
            )}
          </div>
        </div>
      )
    }}
  </CartContext.Consumer>
)

export default WhishList
